import { SVGProps } from 'react';

import { unitMapping } from 'lib/style';

import { IconColor, useIconColor } from './useIconColor';

interface SVGRProps {
  title?: string;
  titleId?: string;
  size?: keyof typeof unitMapping;
  color?: IconColor;
}

export const BasketBall = ({
  title,
  titleId,
  size = 2,
  color,
  ...props
}: Omit<SVGProps<SVGSVGElement>, 'color'> & SVGRProps) => {
  const { fill, svgNode } = useIconColor(color);
  return (
    <svg
      viewBox="0 0 16 16"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      fill="none"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.27143 1.46916C4.34313 0.691862 5.61362 0.171906 6.9922 0V6.99221H4.93899C4.76965 4.73368 4.0551 2.90422 3.34185 1.59661C3.31838 1.55357 3.29489 1.51109 3.27143 1.46916ZM2.91668 6.99221C2.76985 5.33268 2.27872 3.9533 1.75178 2.90435C0.818011 4.04795 0.191975 5.45268 0 6.99221H2.91668ZM1.21352e-06 9.0078H2.91668C2.76985 10.6673 2.27872 12.0467 1.75178 13.0956C0.818013 11.9521 0.191978 10.5473 1.21352e-06 9.0078ZM4.93899 9.0078H6.9922V16C5.61362 15.8281 4.34313 15.3081 3.27143 14.5308C3.29489 14.4889 3.31838 14.4464 3.34185 14.4034C4.0551 13.0958 4.76964 11.2663 4.93899 9.0078ZM9.0078 9.0078V16C10.3864 15.8281 11.6569 15.3081 12.7286 14.5308C12.7051 14.4889 12.6816 14.4464 12.6581 14.4034C11.9449 13.0958 11.2304 11.2663 11.061 9.0078H9.0078ZM13.0833 9.0078C13.2302 10.6673 13.7213 12.0467 14.2482 13.0956C15.182 11.952 15.808 10.5473 16 9.0078H13.0833ZM16 6.99221H13.0833C13.2301 5.33268 13.7213 3.95329 14.2482 2.90434C15.182 4.04794 15.808 5.45267 16 6.99221ZM11.061 6.99221H9.0078V0C10.3864 0.171906 11.6569 0.691858 12.7286 1.46915C12.7051 1.51107 12.6816 1.55355 12.6581 1.59658C11.9449 2.9042 11.2303 4.73366 11.061 6.99221Z"
        fill={fill}
      />
      {svgNode}
    </svg>
  );
};
